import React from 'react';
import { Alert, Box, Tab, Tabs, Typography } from '@mui/material';
import AdminSurface from '../../../components/admin/AdminSurface';
import EmailPipelineDetailsDialog from './EmailPipelineDetailsDialog';
import EmailPipelineFiltersBar from './EmailPipelineFiltersBar';
import EmailPipelineRecordsTable from './EmailPipelineRecordsTable';
import EmailPipelineStatusCard from './EmailPipelineStatusCard';
import { useEmailPipelinePageLogic } from '../hooks/useEmailPipelinePageLogic';
import {
  adminAlertSx,
  adminAlertToneSx,
  adminCardHeaderSx,
  adminCombineSx,
  adminPageHeaderSx,
  adminTabsSx,
} from '../../../styles/adminComponentStyles';

type EmailPipelineContentProps = {
  storeId?: string;
  lockStoreSelection?: boolean;
  title?: string;
};

const EmailPipelineContent: React.FC<EmailPipelineContentProps> = ({
  storeId,
  lockStoreSelection = false,
  title = 'Pipeline Status',
}) => {
  const {
    pageMeta,
    statusCard,
    filters,
    table,
    details,
  } = useEmailPipelinePageLogic({
    initialStoreId: storeId,
    lockStoreSelection,
  });

  if (!pageMeta.isSuperAdmin) {
    return (
      <Box p={3}>
        <Alert severity="error" sx={adminCombineSx(adminAlertSx, adminAlertToneSx.danger)}>
          Access denied. Super admin privileges required.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Box sx={adminPageHeaderSx}>
        <Box>
          <Typography className="AdminPageHeader-title" sx={{mb:0.5, fontSize: '24px !important'}}>{title}</Typography>
          <Typography className="AdminPageHeader-meta">Monitor processing pipelines and retry selected messages.</Typography>
        </Box>
      </Box>

      <EmailPipelineStatusCard model={statusCard.model} />
 <Box sx={adminCardHeaderSx}>
            <Typography className="AdminCardHeader-title">Emails <span className='AdminCardHeader-meta'>({table.model.totalRecords} emails)</span></Typography>
          </Box>
      <AdminSurface sx={{ border: '1px solid #e0e0e0', boxShadow: '0 2px 8px rgb(34 43 69 / 8%)', overflow: 'hidden' }}>

       {/*  <Box sx={{ px: 2, pt: 1.5 }}>

          <Tabs value="emails" sx={adminTabsSx}>
            <Tab label="Emails" value="emails" />
          </Tabs> 
        </Box>*/}

        {table.model.recordsError ? (
          <Alert severity="error" sx={adminCombineSx(adminAlertSx, adminAlertToneSx.danger, { m: 2 })}>
            {table.model.recordsError}
          </Alert>
        ) : null}

        <EmailPipelineFiltersBar
          model={filters.model}
          actions={filters.actions}
        />

        <EmailPipelineRecordsTable
          model={table.model}
          actions={table.actions}
        />
      </AdminSurface>

      <EmailPipelineDetailsDialog
        model={details.model}
        actions={details.actions}
      />
    </Box>
  );
};

export default React.memo(EmailPipelineContent);
